module.exports = __webpack_public_path__ + "assets/img/btn-view-6bdd64bb.png";